import {
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { confirmAction, openNotification, ParagraphHeader } from "@seims/shared";

import { getProfile } from "../../security/AppSecurity";
import { Messages, Notify } from "../../services/custom/Messages";
import { usersService as api } from "../../services/usersService";
import { util } from "../../utils/functions/custom";
import { recordError } from "../../utils/logService";

import "./userManagement.css";

/**
 * Used loggedin users intending to update their account names.
 * 
 * @component
 * @param {Object} props
 * @param {boolean} [props.showTitle] - Optional flag to toggle visibility of title. Defaults to invisible title.
 */
export const UserProfile = ({ showTitle = false }) => {

  const [form] = Form.useForm();

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const userData = getProfile();
    form.setFieldsValue({
      firstName: userData?.firstName || "",
      lastName: userData?.lastName || "",
      emailAddress: userData?.emailAddress || "",
    });
  }, [form]);

  const formName = "UserProfile";
  const navigate = useNavigate();
  let path = `/`;

  const onSubmit = async (values) => {
    try {
      const { firstName, lastName } = values;

      const profileValues = {
        firstname: firstName,
        lastname: lastName,
      };
      const request = await api.updateUserProfile(profileValues);

      let msg;

      if (request.status === 200 || request.status === 201) {

        msg = util.parseMessage(
          Messages.UPDATE_SUCCESSWITHOK,
          "Profile info detail(s)"
        );
        openNotification("Updating Profile", msg, Notify.SUCCESS);
        navigate("/");
        return;
      }

      msg = util.parseMessage(
        Messages.UPDATE_FAILURE,
        "Profile info detail(s)"
      );
      openNotification("Updating Profile", msg, Notify.ERROR);
    } catch (error) {
      openNotification(
        "Updating Profile",
        "SYSTEM FAILED TO UPDATE",
        Notify.ERROR
      );
      recordError(error)
    } finally {
      setSubmitting(false);
    }
  };

  const onFirstnameBlur = (e) => {
    const { value, firstname } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [firstname]: textValue });
  };

  const onLastnameBlur = (e) => {
    const { value, lastname } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [lastname]: textValue });
  };

  const handleCancel = () => {
    confirmAction({
      title: "Are you sure you want to cancel?",
      description: "You will lose all entered information.",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      className: "pwa-confirm", // pass through styling
      onOk: () => {
        navigate(path);
      },
    });
  };

  return (
    <div>
      <Row className="user-profile-container">
        <Col className="user-profile-card">
          {showTitle &&
            <ParagraphHeader header="Update Profile" />
          }
          <Form layout="vertical" name={formName} form={form} onFinish={onSubmit}>
            <Form.Item
              disabled
              name="emailAddress"
              label="Username"
              rules={[
                {
                  required: true,
                  message: "Username may not be empty",
                },
              ]}
            >
              <Input name="emailAddress" disabled />
            </Form.Item>
            <Form.Item
              name="firstName"
              label="First name"
              rules={[
                {
                  required: true,
                  message: "Firstname may not be empty",
                },
              ]}
            >
              <Input name="firstName" onBlur={onFirstnameBlur} />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="Last name"
              rules={[
                {
                  required: true,
                  message: "Lastname may not be empty",
                },
              ]}
            >
              <Input name="lastName" onBlur={onLastnameBlur} />
            </Form.Item>
            <Row>
              <Col xs={24} className="center-align">

                <div className="user-profile-actions">
                  <Button className="user-btn user-btn-cancel" onClick={handleCancel}>
                    Cancel
                  </Button>

                  <Button
                    className="user-btn user-btn-primary"
                    htmlType="submit"
                    loading={submitting}
                    disabled={submitting}
                  >
                    Update
                  </Button>
                </div>

              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
};
